// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Post_container__HGhnv {
  max-width: 500px;
  margin: 40px auto;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.Post_form__0d83J {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.Post_input__nZ0WR, .Post_textarea__xp-\\+B {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}
.Post_textarea__xp-\\+B {
  min-height: 100px;
  resize: vertical;
}
.Post_button__AKqR9 {
  background: #1976d2;
  color: #fff;
  border: none;
  padding: 10px 0;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.Post_button__AKqR9:hover {
  background: #1565c0;
}

.Post_imagePreviewArea__xOxBv {
  display: flex;
  gap: 12px;
  margin: 8px 0 8px 0;
}
.Post_imagePreviewWrapper__HSYCP {
  position: relative;
  display: inline-block;
}
.Post_imagePreview__dq0Gx {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #f8f8f8;
}
.Post_deleteImageButton__TaSyx {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: background 0.2s;
}
.Post_deleteImageButton__TaSyx:hover {
  background: #d32f2f;
}

.Post_imageUploadBlock__yvz9m {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 8px 0;
}
.Post_addImageButton__k9jpg {
  background: #fff;
  color: #1976d2;
  border: 1px solid #1976d2;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.Post_addImageButton__k9jpg:disabled {
  color: #aaa;
  border-color: #ccc;
  cursor: not-allowed;
  background: #f5f5f5;
}
.Post_addImageButton__k9jpg:not(:disabled):hover {
  background: #1976d2;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Post/Post.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".container {\r\n  max-width: 500px;\r\n  margin: 40px auto;\r\n  padding: 24px;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n}\r\n.form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n.input, .textarea {\r\n  width: 100%;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n}\r\n.textarea {\r\n  min-height: 100px;\r\n  resize: vertical;\r\n}\r\n.button {\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 10px 0;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.button:hover {\r\n  background: #1565c0;\r\n}\r\n\r\n.imagePreviewArea {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin: 8px 0 8px 0;\r\n}\r\n.imagePreviewWrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n.imagePreview {\r\n  width: 100px;\r\n  height: 100px;\r\n  object-fit: cover;\r\n  border-radius: 6px;\r\n  border: 1px solid #ccc;\r\n  background: #f8f8f8;\r\n}\r\n.deleteImageButton {\r\n  position: absolute;\r\n  top: 2px;\r\n  right: 2px;\r\n  background: rgba(0,0,0,0.6);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 24px;\r\n  height: 24px;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 2;\r\n  transition: background 0.2s;\r\n}\r\n.deleteImageButton:hover {\r\n  background: #d32f2f;\r\n}\r\n\r\n.imageUploadBlock {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin: 8px 0 8px 0;\r\n}\r\n.addImageButton {\r\n  background: #fff;\r\n  color: #1976d2;\r\n  border: 1px solid #1976d2;\r\n  border-radius: 4px;\r\n  padding: 6px 16px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n.addImageButton:disabled {\r\n  color: #aaa;\r\n  border-color: #ccc;\r\n  cursor: not-allowed;\r\n  background: #f5f5f5;\r\n}\r\n.addImageButton:not(:disabled):hover {\r\n  background: #1976d2;\r\n  color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Post_container__HGhnv`,
	"form": `Post_form__0d83J`,
	"input": `Post_input__nZ0WR`,
	"textarea": `Post_textarea__xp-+B`,
	"button": `Post_button__AKqR9`,
	"imagePreviewArea": `Post_imagePreviewArea__xOxBv`,
	"imagePreviewWrapper": `Post_imagePreviewWrapper__HSYCP`,
	"imagePreview": `Post_imagePreview__dq0Gx`,
	"deleteImageButton": `Post_deleteImageButton__TaSyx`,
	"imageUploadBlock": `Post_imageUploadBlock__yvz9m`,
	"addImageButton": `Post_addImageButton__k9jpg`
};
export default ___CSS_LOADER_EXPORT___;
